require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-importance-of-computer-science-to-software-engineers-doing-web-development.json") })
        }
      }, "path---blog-importance-of-computer-science-to-software-engineers-doing-web-development");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-importance-of-computer-science-to-software-engineers-doing-web-development!./.cache/json/blog-importance-of-computer-science-to-software-engineers-doing-web-development.json
// module id = 885
// module chunks = 231608221292675